import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    socialLeadId: "",
    chatRoomId: "",
    reload: "",
    friendUnread: [],
    groupUnread: [],
    friendList: [],
    groupId: []
  },
  getters: {},
  actions: {
    selectSocialLead: function (context, payload) {

      context.commit("select_SocialLead", payload);
    },
    RefreshUnreadCount: function (context, friendUnread) {
      context.commit("refresh_UnreadCount", friendUnread);
    },
    refreshGroupUnreadCount: function (context, groupUnread) {
      context.commit("refresh_GroupUnreadCount", groupUnread);
    },
    GetFriendList: function (context, friendList) {
      context.commit("get_FriendList", friendList);
    }
  },
  mutations: {
    select_SocialLead: function (state, payload) {
      state.reload = new Date();
      state.socialLeadId = payload.socialLeadId;
      state.chatRoomId = payload.chatRoomId;
    },
    refresh_UnreadCount: function (state, payload) {
      state.friendUnread = payload;
    },
    refresh_GroupUnreadCount: function (state, payload) {
      state.groupUnread = payload;
    },
    get_FriendList: function (state, payload) {
      state.friendList = payload;
    }
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/vuex/store_friendList.js